/**
 * getLabel
 * @param {*} label The label text to be applied to the MenuButton.
 * @param {*} responsive Responsive properties supplied by the `responsive` prop.
 */
const getLabel = (label, responsive) => {
  let finalLabel = "";

  if (label && responsive === "block") {
    finalLabel = label;
  } else if (label && responsive === false || !label) {
    finalLabel = "";
  } else {
    finalLabel = label;
  }

  return finalLabel;
};

export { getLabel };